/**
 * Radar Chart test data
 */
export default function radarTestData() {
  return [
    [
      {axis:"eye",value:3},
      {axis:"constitutionxal",value:2},
      {axis:"neoplasm",value:5},
      {axis:"ear",value:3},
      {axis:"endocrine system",value:2},
      {axis:"metabolism/homeostasis",value:3},
      {axis:"respiratory system",value:1},
      {axis:"integument",value:1},
      {axis:"growth",value:1},
      {axis:"head or neck",value:0},
      {axis:"immune system",value:1},
      {axis:"blood and blood-forming tissues",value:1},
      {axis:"thoracic cavity",value:0},
      {axis:"connective tissue",value:0},
      {axis:"voice",value:0},
      {axis:"nervous system",value:0},
      {axis:"breast",value:0},
      {axis:"prenatal development or birth",value:0},
      {axis:"limbs",value:0},
      {axis:"digestive system",value:0},
      {axis:"musculature",value:0},
      {axis:"cardiovascular system",value:0},
      {axis:"skeletal system",value:0},
      {axis:"genitourinary system",value:0},
      {axis:"cellular",value:0},
    ],
    [
      {axis:"eye",value:2},
      {axis:"constitutional",value:1},
      {axis:"neoplasm",value:2},
      {axis:"ear",value:6},
      {axis:"endocrine system",value:1},
      {axis:"metabolism/homeostasis",value:3},
      {axis:"respiratory system",value:1},
      {axis:"integument",value:1},
      {axis:"growth",value:1},
      {axis:"head or neck",value:1},
      {axis:"immune system",value:0},
      {axis:"blood and blood-forming tissues",value:0},
      {axis:"thoracic cavity",value:2},
      {axis:"connective tissue",value:0},
      {axis:"voice",value:0},
      {axis:"nervous system",value:0},
      {axis:"breast",value:0},
      {axis:"prenatal development or birth",value:0},
      {axis:"limbs",value:0},
      {axis:"digestive system",value:0},
      {axis:"musculature",value:0},
      {axis:"cardiovascular system",value:0},
      {axis:"skeletal system",value:0},
      {axis:"genitourinary system",value:0},
      {axis:"cellular",value:0},
    ]
  ];
}


// WEBPACK FOOTER //
// ./src/components/Radar/Radar.testData.js